import { queryOptions } from '@tanstack/react-query';

import type { ArShapesQueryParams } from '~api/services';
import { arShapesService } from '~api/services';

const arShapesQueryOptions = (params: ArShapesQueryParams) =>
  queryOptions({
    queryKey: [
      'ar-shapes',
      params.blast_name,
      params.mine_site,
      params.permit_type ?? 'blasting',
      params.crs ?? 'local',
    ],
    queryFn: () => arShapesService.getArShapes(params),
  });

export { arShapesQueryOptions };
